import styled from 'styled-components/macro';

export const IconWrapper = styled.div`
  width: 14px;
  height: 14px;
  border-radius: 7px;
  margin: 0px;
  font-size: 7px;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  position: relative;
`;

export const NumberContainer = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
`;

export const DollarSign = styled.div`
  width: 14px;
  height: 14px;
  text-align: center;
  position: absolute;
  top: 32%;
  left: 50%;
  transform: translate(-50%, -50%);
  animation: blink_dollar 9s ease-out infinite;
  @keyframes blink_dollar {
    0% {
      opacity: 0;
    }
    7% {
      opacity: 1;
    }
    14% {
      opacity: 0;
    }
    21% {
      opacity: 1;
    }
    28% {
      opacity: 0;
    }
    35% {
      opacity: 1;
    }
    42% {
      opacity: 0;
    }
    100% {
      opacity: 0;
    }
  }
`;

export const Number = styled.div`
  width: 14px;
  height: 14px;
  text-align: center;

  position: absolute;
  top: 32%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

export const BlinkAnimatedNumber = styled(Number)`
  animation: blink 9s ease-out infinite;
  @keyframes blink {
    0% {
      opacity: 0;
    }
    41% {
      opacity: 0;
    }
    42% {
      opacity: 1;
    }
    93% {
      opacity: 1;
    }
    100% {
      opacity: 0;
    }
  }
`;

export const InnerNumber = styled.div`
  background-color: ${(props) => props.$color};
  color: white;
  height: 28px;
  width: 14px;
  position: absolute;
  bottom: -14px;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  flex-direction: column;
  transition: 1s;
  div {
    color: white;
  }

  animation-name: scrollDown;
  animation-direction: forwards;
  animation-duration: 1s;
  @keyframes scrollDown {
    0% {
      bottom: 0px;
    }

    100% {
      bottom: -14px;
    }
  }
`;
